import PositionLog from '@/data/position_log'
import WX_API from '@/utils/wx_api'

let task

let obs = []
export default {
    watch: {
        list (latest) {
            if (latest.length) {
                PositionLog.refresh(this.type)
                this.startTask()
            } else {
                this.cancelTask()
            }
        }
    },
    mounted () {
        this.$nextTick(this.startTask)
    },
    beforeDestroy () {
        this.cancelTask()
    },
    methods: {
        startTask () {
            task = setTimeout(() => {
                this.list.forEach((item, i) => {
                    const ob = WX_API.observerRelativeViewPort(`.${item.class}`, {
                        relativeOpt: {
                            top: 0,
                            bottom: 0
                        },
                        success: (res) => {
                            const { item, index } = res.dataset
                            PositionLog.log(this.type, {
                                id: item.log_id,
                                pos: index,
                                pos_name: item.position
                            })
                        }
                    }, this.$mp.component)
                    ob && obs.push(ob)
                })
            }, 1500)
        },
        cancelTask () {
            task && clearTimeout(task)
            obs.forEach((ob) => {
                ob.disconnect()
            })
            obs = []
        }
    }
}
